import { combineReducers } from 'redux';
import { StateType } from "typesafe-actions";

import { JobReducer } from './jobReducer'
import { GrainTypeReducer } from './grainTypeReducer'
import { GrainProfileReducer } from './grainProfileReducer'
import { UploadReducer } from './uploadReducer'
import { ProductReleaseReducer } from './productReleaseReducer'
import { BluetoothReducer } from './bluetoothReducer'
import { AppReducer } from './appReducer'
import { OrgReducer } from './orgReducer'
import { NotificationReducer } from './notification'
import { ReportReducer } from './reportReducer'
import { LoginReducer } from './loginReducer'
import { UserReducer } from './userReducer'
import { UserGuideReducer } from './userGuideReducer';
import { DatasetReducer } from './datasetReducer';
import { trainingReducer } from './trainingReducer';
import { subscriptionReducer } from 'src/redux/reducers/subscriptionReducer';
import { testingJobReducer } from './testingReducer';
import { updateReducer } from './updateReducer';
import { SettingsReducer } from './settingsReducer';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { persistReducer } from 'redux-persist';
import { migratePersistedState } from '../persistMigration';

const rootReducer = combineReducers({
  job: JobReducer,
  grainType: GrainTypeReducer,
  grainProfile: GrainProfileReducer,
  upload: UploadReducer,
  app: AppReducer,
  org: OrgReducer,
  bluetooth: BluetoothReducer,
  notification: NotificationReducer,
  report: ReportReducer,
  login: LoginReducer,
  user: UserReducer,
  productRelease: ProductReleaseReducer,
  userGuide: UserGuideReducer,
  dataset: DatasetReducer,
  training: trainingReducer,
  subscription: subscriptionReducer,
  testing: testingJobReducer,
  update: updateReducer,
  settings: SettingsReducer
});

const persistConfig = {
  key: 'rootv2',
  version: 5,
  storage: AsyncStorage,
  migrate: migratePersistedState,
  whitelist: [
    'app',
    'grainType',
    'grainProfile',
    'notification',
    'org',
    'user',
    'settings'
  ]
};

export const pReducer = persistReducer(persistConfig, rootReducer);

export * from "./jobReducer";
export * from "./grainTypeReducer";
export * from "./grainProfileReducer";
export * from "./uploadReducer";
export * from "./appReducer";
export * from "./orgReducer";
export * from "./bluetoothReducer";
export * from "./notification";
export * from "./reportReducer";
export * from "./loginReducer";
export * from "./userReducer";
export * from "./productReleaseReducer";
export * from "./userGuideReducer";
export * from "./datasetReducer";
export * from "./trainingReducer";
export * from "./subscriptionReducer";
export * from "./testingReducer";
export * from "./updateReducer";
export * from "./settingsReducer";
export type IStore = StateType<typeof pReducer>;
